module.exports = __webpack_public_path__ + "img/donut.bbbf9a99.svg";